import React, { useState, Fragment, useEffect, createContext } from 'react';
import { useApolloClient } from '@apollo/client';
import { EirCustomerDetailsContainer } from './EirCustomerDetailsContainer';
import EirReviewOrderContainer from '../eir-review-order/EirReviewOrderContainer';
import EirPayment from '../eir-order-payment/EirPayment';
import { Stepper, Step, StepLabel, Grid, Box } from '@material-ui/core';
import { EirConfirmationContainer } from '../eir-confirmation-container/EirConfirmationContainer';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../styles/theme';
import { Route, BrowserRouter, matchPath } from 'react-router-dom';
import { CHECKOUT_URLS } from './constants';
import ENDPOINT from '../graphql/GraphQLConstants';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import Loading from '../shared/Loading';
import EirEmptyCart from '../eir-review-order/EirEmptyCart';
import { PREPAY_PLAN_URL } from '../eir-prepay-constants/ApplicationConstants';
export const CheckoutContext = createContext();

export default function EirCheckoutContainer(props) {
	const { feedbackUrl } = props;
	const [currentUrl, setCurrentUrl] = useState(CHECKOUT_URLS.REVIEW_ORDER_URL);
	const [customerInformation, setCustomerInformation] = useState(null);
	const [cartDetails, setCartDetails] = useState(null);
	const [totalPrice, setTotalPrice] = useState(0);
	const graphql = useApolloClient();
	const[isLoading,setIsLoading]=useState(true);
	useEffect(() => {
		const prospectUuid = localStorage.getItem('prospectUuid');
		PubSub.subscribe(Constants.eventKeys.updatedCartDetails, publishCart);
		if(prospectUuid){	
			getCustomerDetails(prospectUuid).then(data => {
			setCustomerInformation(data.customerDetails);
		});
			getCartDetails(prospectUuid).then(data => {
			setCartDetails(data.cartDetails);
			setTotalPrice(calculateTotalPrice(data.cartDetails));			
		})
		}
		else{
			setIsLoading(false);
		}
	}, []);

	const publishCart = (msg, data) => {
		if (data) {
			setCartDetails(data);
			setTotalPrice(calculateTotalPrice(data));
		}
	};
	const calculateTotalPrice = (priceDetails) => {
		let total = 0;
		if (priceDetails.device) {
			if (priceDetails.discount) {
				total = total + parseFloat(priceDetails.device.fromPrice);
			} else {
				total = total + parseFloat(priceDetails.device.price);
			}
		}
		if (priceDetails.topUpAmount) {
			total = total + (parseFloat(priceDetails.topUpAmount));
		}
		return total.toFixed(2);
	}


	const getCustomerDetails = async (prospectUuid) => {

		const customerDetails = await graphql.query({
			query: ENDPOINT.GET_CUSTOMERDETAILS,
			variables: {
				prospectUuid: prospectUuid,
			},
		});
		return customerDetails.data;
	}

	const getCartDetails = async (prospectUuid) => {
		try {
			const res = await graphql.query({
				query: ENDPOINT.GET_CART_DETAILS,
				variables: { prospectUuid: prospectUuid },
			});
			if (res.data.cartDetails) {
				setIsLoading(false);
				return res.data;
			}
		} catch (err) {
			setIsLoading(false);
			console.log(err.message);
		}
	};

	const steps = [
		{
			label: 'Review your order',
			url: CHECKOUT_URLS.REVIEW_ORDER_URL,
			component: <EirReviewOrderContainer setCurrentUrl={setCurrentUrl} nextStepUrl={CHECKOUT_URLS.CUSTOMER_DETAILS_URL} />,
		},
		{
			label: 'Customer details',
			url: CHECKOUT_URLS.CUSTOMER_DETAILS_URL,
			component: <EirCustomerDetailsContainer setCurrentUrl={setCurrentUrl} nextStepUrl={CHECKOUT_URLS.PAYMENT_URL} customerInformation={customerInformation} setCustomerInformation={setCustomerInformation} />,
		},
		{
			label: 'Payment',
			url: CHECKOUT_URLS.PAYMENT_URL,
			component: <EirPayment setCurrentUrl={setCurrentUrl} nextStepUrl={CHECKOUT_URLS.CONFIRMATION_URL} />,

		},
		{
			label: 'Confirmation',
			url: CHECKOUT_URLS.CONFIRMATION_URL,
			component: <EirConfirmationContainer setCurrentUrl={setCurrentUrl} feedbackUrl={feedbackUrl} />,
		}];

	if (isLoading) {
		return (<Loading className="m-5" />);
	}else if(cartDetails==null){
		return (<EirEmptyCart url={PREPAY_PLAN_URL}/>);
	}
	else{
	return (
		<Fragment>
			<ThemeProvider theme={theme}>
				<CheckoutContext.Provider value={{ cartDetails, setCartDetails, totalPrice }}>
					<Grid container>
						<Grid item xs={12} >
							<Box display={{ xs: 'none', md: 'block' }} >
								<Stepper activeStep={steps.findIndex((step) => matchPath(currentUrl, step.url))}>
									{steps.map((step) => (
										<Step key={step.label}>
											<StepLabel>{step.label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Box>
							<Box display={{ xs: 'block', md: 'none' }} >
								<Stepper alternativeLabel activeStep={steps.findIndex((step) => matchPath(currentUrl, step.url))}>
									{steps.map((step) => (
										<Step key={step.label}>
											<StepLabel>{step.label}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Box>
						</Grid>
					</Grid>
					<Fragment>
						<BrowserRouter basename='/checkout'>
							{steps.map((step) => (
								<Route key={step.label} path={step.url}
									render={() => (step.component)}>
								</Route>
							))}
						</BrowserRouter>
					</Fragment>
				</CheckoutContext.Provider>
			</ThemeProvider>
		</Fragment>
	);
	}
}